import type { ReactNode } from 'react';
import { Alert } from '@org/design-system';
import { useRuntimeAuth, type AppConfig } from '@org/runtime-engine';
import type { RuntimeUserRole } from '../types';
import { hasRequiredRole, normalizeRuntimeRole, resolveUserIdFromToken } from './roles';

interface RoleGateProps {
  requiredRole: RuntimeUserRole;
  roles?: Record<string, RuntimeUserRole>;
  auth?: AppConfig['auth'];
  children: ReactNode;
}

export function RoleGate({ requiredRole, roles, auth, children }: RoleGateProps) {
  const { token, role } = useRuntimeAuth();

  const userId = resolveUserIdFromToken(token, auth);
  const mappedRole = userId ? roles?.[userId] : undefined;
  const effectiveRole = normalizeRuntimeRole(mappedRole ?? role);

  if (hasRequiredRole(effectiveRole, requiredRole)) {
    return <>{children}</>;
  }

  return (
    <Alert
      variant="error"
      title="Access denied"
      description="You don't have enough permissions to view this section."
    />
  );
}
